<div class="mb-carousel"
     aria-label="Gallery carousel slider"
     data-cy="mbGalleryCarouselWrapper"
     *ngIf="!!imagesData && imagesData?.length > 1">
  <img src="../../../../../assets/icons/svg/arrow_up.svg"
       class="mb-carousel-arrow up"
       title="Carousel arrow up"
       alt="Carousel arrow up"
       aria-label="Carousel slider arrow up"
       data-cy="mbCarouselArrowUp"
       (click)="onCarouselCaretClick(true)"/>
  <div #galleryCarousel
       aria-label="mbGalleryCarousel"
       class="mb-carousel-slides hide-scrollbar my-3">
    <div *ngFor="let imageData of imagesData; index as i"
         (click)="onGalleryImageClick(imageData, i)"
         [ngClass]="[i === activeImgIndex ? 'mb-carousel-active-image' : 'mb-carousel-inactive-image']">
      <ng-container *ngIf="imageData?.videoId; else showImage">
        <ng-container *ngIf="getThumbnail(imageData?.videoId) as thumbnail">
          <span *ngIf="thumbnail?.image"
                mbUcBlockable
                [ucService]="ucService.MOVING_IMAGE"
                [ucId]="imageData.videoId"
                [useBasicThumbnail]="true">
            <img class="mb-carousel-image mb-carousel-video-image"
                 title="Slider image"
                 alt="Slider image"
                 aria-label="Slider image"
                 data-cy="mbGalleryCarouselImage"
                 [src]="thumbnail?.image"/>
            <img src="../../../../../assets/images/Icon_play-xl2_white.svg"
                 class="mb-carousel-video-play-button"
                 data-cy="mb-carousel-video-play-button"
                 alt="Carousel play video icon"
                 title="Carousel play video icon"
                 aria-label="Carousel play video icon"/>
          </span>
        </ng-container>
      </ng-container>
      <ng-template #showImage>
        <span *ngIf="imageData?.image">
          <img class="mb-carousel-image p-2"
               title="Slider image"
               alt="Slider image"
               aria-label="Slider image"
               data-cy="mbGalleryCarouselImage"
               [src]="imageData?.image"/>
        </span>
      </ng-template>
    </div>
  </div>
  <img src="../../../../../assets/icons/svg/arrow_down.svg"
       class="mb-carousel-arrow down"
       title="Carousel arrow down"
       alt="Carousel arrow down"
       aria-label="Carousel slider arrow down"
       data-cy="mbCarouselArrowDowm"
       (click)="onCarouselCaretClick(false)"/>
</div>

